module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "details",
    staticClass: "details",
    attrs: {
      "id": "form-top"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "wwf-field"
  }, [_c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('firstName')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("firstName")) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('firstName'),
        empty: !_vm.firstName,
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "data-vv-as": "first name",
      "placeholder": "FIRST NAME",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logTouch('firstName')
      },
      "blur": function($event) {
        _vm.logFieldComplete('First Name Field Completed')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('lastName')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("lastName")) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('lastName'),
        empty: !_vm.lastName,
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "data-vv-as": "last name",
      "placeholder": "LAST NAME",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logTouch('lastName')
      },
      "blur": function($event) {
        _vm.logFieldComplete('Last Name Field Completed')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("email")) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        supportDetailsCheckEmail: true
      }),
      expression: "{ required: true, supportDetailsCheckEmail: true }"
    }],
    class: {
      error: _vm.errors.has('email'),
        empty: !_vm.email,
    },
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "placeholder": "EMAIL ADDRESS",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "focus": function($event) {
        _vm.logTouch('email')
      },
      "blur": function($event) {
        _vm.logFieldComplete('Email Address Completed')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('phone')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("phone")) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.requirePhone,
        phoneNumberIsValid: true
      }),
      expression: "{ required: requirePhone, phoneNumberIsValid: true }"
    }],
    class: {
      error: _vm.errors.has('phone'),
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "min": "8",
      "max": "12",
      "data-vv-as": "phone",
      "placeholder": _vm.requirePhone ? 'PHONE NUMBER' : 'PHONE NUMBER (OPTIONAL)',
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "focus": function($event) {
        _vm.logTouch('phone')
      },
      "blur": function($event) {
        _vm.logFieldComplete('Phone Number Added')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('postcode')) ? _c('p', [_vm._v("\n            " + _vm._s(_vm.errors.first("postcode")) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        postcodeIsValid: true
      }),
      expression: "{ required: true, postcodeIsValid: true }"
    }],
    class: {
      error: _vm.errors.has('postcode'),
    },
    attrs: {
      "name": "postcode",
      "type": "text",
      "data-vv-as": "postcode",
      "placeholder": "POSTCODE"
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }, _vm.updateElectorates],
      "focus": function($event) {
        _vm.logTouch('postcode')
      },
      "blur": function($event) {
        _vm.logPostcode()
      }
    }
  })]), _vm._v(" "), (_vm.isValidPostcode) ? _c('div', {
    staticClass: "wwf-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedElectorate),
      expression: "selectedElectorate"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedElectorate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.electoratesList), function(electorate) {
    return _c('option', {
      key: electorate,
      domProps: {
        "value": electorate
      }
    }, [_vm._v("\n            " + _vm._s(electorate) + "\n          ")])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.isEmailInError) ? _c('div', {
    staticClass: "submit-email-error"
  }, [_c('p', [_vm._v("You can only submit the petition once.")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "submit-btn",
    attrs: {
      "type": "button",
      "name": "takeAction"
    },
    on: {
      "click": function($event) {
        _vm.takeAction()
      }
    }
  }, [(_vm.isSaving) ? _c('span', [_c('i', {
    staticClass: "far fa-spinner-third fa-spin"
  })]) : _c('span', [_vm._v(" Take Action ")])]), _vm._v(" "), _c('div', {
    staticClass: "privacy-policy"
  }, [_c('p', [_vm._v("\n        By signing you accept\n        "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    },
    on: {
      "click": _vm.logPrivacy
    }
  }, [_vm._v("\n          WWF-Australia’s Privacy Policy.\n        ")])])]), _vm._v(" "), _c('button', {
    staticClass: "secondary",
    attrs: {
      "type": "button",
      "name": "viewMessage"
    },
    on: {
      "click": _vm.toggleMessage
    }
  }, [_vm._v("\n      View your email to the representative\n      "), (_vm.viewMessage) ? _c('i', {
    staticClass: "fa fa-angle-up"
  }) : _vm._e(), _vm._v(" "), (!_vm.viewMessage) ? _c('i', {
    staticClass: "fa fa-angle-down"
  }) : _vm._e()])]), _vm._v(" "), (_vm.viewMessage) ? _c('div', {
    staticClass: "message-content"
  }, [_c('FormMessageViewer', {
    attrs: {
      "firstName": _vm.firstName,
      "lastName": _vm.lastName,
      "email": _vm.email,
      "postcode": _vm.postcode,
      "electorateName": _vm.selectedElectorate,
      "isValidPostcode": _vm.isValidPostcode,
      "messageId": _vm.messageId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back-top"
  }, [_c('div', {
    staticClass: "clickable",
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  }), _vm._v(" "), _c('p', [_vm._v("Back to top")])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Help Protect our wildlife")]), _vm._v(" "), _c('p', [_vm._v("\n      Email your local representative asking for stronger protection of our\n      wildlife now.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3789da4f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/threatened-species/form-components/SupporterDetails.vue
// module id = 739
// module chunks = 0